export const types = {
  SET_LOADER_STATE: 'LOADERCONTROL/SET_LOADER_STATE',
  SET_LOADING_BLOCKED: 'LOADING_BLOCKED/SET_LOADING_BLOCKED',
};

export const initialState = {
  loading: true,
  loadingBlocked: false,
  loadingText: 'Preparando tu pedido',
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const LoaderControlReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LOADER_STATE: {
      const {
        loading,
        loadingText,
      } = action.payload;

      const {
        loadingBlocked,
      } = state;

      if (loadingBlocked) {
        return {
          ...state,
        };
      }

      const newLoader = {
        loading,
        loadingText: loadingText || state.loadingText,
      };
      return {
        ...state,
        ...newLoader,
      };
    }
    case types.SET_LOADING_BLOCKED: {
      return {
        ...state,
        loadingBlocked: true,
      };
    }
    default:
      return { ...state };
  }
};

export const actions = {
  setLoaderState: loaderState => ({
    type: types.SET_LOADER_STATE,
    payload: {
      ...loaderState,
    },
  }),
  setLoadingBlocked: () => ({
    type: types.SET_LOADING_BLOCKED,
  }),
};

export default LoaderControlReducer;
